import { render, staticRenderFns } from "./WithdrawModal.vue?vue&type=template&id=cc5c7272&scoped=true"
import script from "./WithdrawModal.vue?vue&type=script&lang=js"
export * from "./WithdrawModal.vue?vue&type=script&lang=js"
import style0 from "./WithdrawModal.vue?vue&type=style&index=0&id=cc5c7272&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5c7272",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc5c7272')) {
      api.createRecord('cc5c7272', component.options)
    } else {
      api.reload('cc5c7272', component.options)
    }
    module.hot.accept("./WithdrawModal.vue?vue&type=template&id=cc5c7272&scoped=true", function () {
      api.rerender('cc5c7272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data/components/Modal/WithdrawModal.vue"
export default component.exports